import React, {Component} from "react";

import OmzetTotal from "./common/Omzet/Total";
import OrdersTotal from "./common/Orders/Total";
import Reviews from "./common/Reviews/Main";
import {
    NAMESPACE_DEFAULT,
    NAMESPACE_CUSTOMER_SERVICE,
    NAMESPACE_RMA,
} from "../actions/types";

import {connect} from "react-redux";
import {openWebsocket} from "../actions/actions";
import PropTypes from "prop-types";
import MobileMenu from "./common/Profile/Mobile/MobileMenu";
import Loader from "./common/Loader";
import OmzetToppy from "./common/Omzet/Toppy";
import OrdersToppy from "./common/Orders/Toppy";
import OmzetHeuts from "./common/Omzet/Heuts";
import OrdersHeuts from "./common/Orders/Heuts";
import OrdersTable from "./common/Orders/OrdersTable";
import Achievements from "./Content/Achievements";

class CustomerService extends Component {
    componentDidMount() {
        this.connectSockets();
    }

    connectSockets = () => {
        this.props.openWebsocket(NAMESPACE_DEFAULT);
        this.props.openWebsocket(NAMESPACE_CUSTOMER_SERVICE);
        this.props.openWebsocket(NAMESPACE_RMA);
    }


    render() {
        let {loaded} = this.props.result;
        if (loaded.tickets && loaded.reviews && loaded.toppyRevenue && loaded.heutsRevenue && loaded.rma) {
            if (this.props.history.location.pathname === '/customer-service') {
                return (
                    <div>
                        <div className={this.props.result.tvMode ? "customer-service tv" : "customer-service"}>
                            <div id="left" className="medium-column">
                                <OmzetToppy/>
                                <OrdersToppy/>
                                <Reviews/>
                            </div>
                            <div id="center" className="medium-column">
                                <OmzetHeuts/>
                                <OrdersHeuts/>
                                <Achievements />
                            </div>
                            <div id="right" className="medium-column">
                                <OmzetTotal/>
                                <OrdersTotal/>
                                <div id="orders" className="block">
                                    <OrdersTable/>
                                </div>
                            </div>
                        </div>
                        <MobileMenu/>
                    </div>
                );
            } else {
                return null
            }
        } else {
            return <Loader show={true}/>
        }


    }
}

CustomerService.propTypes = {
    openWebsocket: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    let result = {};
    let loaded = {tickets: false, toppyRevenue: false, heutsRevenue: false, reviews: false, rma: false};
    loaded.tickets = true;
    if (typeof state.data["event-robin-tickets"] !== "undefined") {
        loaded.tickets = true;
    }
    if (typeof state.data["event-rma-per-state-count"] !== "undefined") {
        loaded.rma = true;
    }
    if (typeof state.data["event-kiyoh-latest-reviews"] !== "undefined") {
        loaded.reviews = true;
    }
    if (typeof state.data["event-toppy-current-stats"] !== "undefined") {
        loaded.toppyRevenue = true;
    }
    if (typeof state.data["event-heuts-current-stats"] !== "undefined") {
        loaded.heutsRevenue = true;
    }
    result.loaded = loaded;
    result.tvMode = state.app.tvMode;
    return {result};
};

export default connect(
    mapStateToProps,
    {openWebsocket}
)(CustomerService);
